import {
  SET_CONTACT_LIST,
  SET_SIDEBAR_VAL,
  SET_INDEX,
  SET_INDEX2,
  SET_READY_BUTTON,
  SET_SHOWING_STATUS_VOICE,
  SET_SHOWING_STATUS,
  SET_SHOWING_STATUS_CLASS,
  SET_SELECTED_MENU,
  SET_SELECTED_EXTERNAL_CHAT_TYPE,
  SET_SOCKET_RECONNECT,
  SET_ARRIVAL_MESSAGE,
} from "../../redux/actions/type";
const initialState1 = {
  contactList: [],
  sidebarVal: "Dashboard",
  index: 0,
  index2: 0,
  readyButton: false,
  showingStatus: "Connected",
  showingStatusVoice: "Connected",
  showingStatusClass: "showStatusConnected",
  selectedExternalChatType: "",
  socketrefresh: false,
  arrivalMessage: null,
  selectedMenu: "ReportMenu",
};

export const contactListReducer = (state = initialState1, action) => {
  switch (action.type) {
    case SET_ARRIVAL_MESSAGE:
      return {
        ...state,
        arrivalMessage: action.val,
      };
    case SET_SELECTED_EXTERNAL_CHAT_TYPE:
      return {
        ...state,
        selectedExternalChatType: action.val,
      };
    case SET_SELECTED_MENU:
      return {
        ...state,
        selectedMenu: action.val,
      };
    case SET_READY_BUTTON:
      return {
        ...state,
        readyButton: action.val,
      };

    case SET_SHOWING_STATUS: {
      return {
        ...state,
        showingStatus: action.val,
      };
    }
    case SET_SHOWING_STATUS_VOICE: {
      return {
        ...state,
        showingStatusVoice: action.val,
      };
    }
    case SET_SHOWING_STATUS_CLASS: {
      return {
        ...state,
        showingStatusClass: action.val,
      };
    }
    case SET_CONTACT_LIST:
      return {
        ...state,
        contactList: action.val,
      };
    case SET_SIDEBAR_VAL: {
      return {
        ...state,
        sidebarVal: action.val,
      };
    }
    case SET_INDEX: {
      return {
        ...state,
        index: action.val,
      };
    }
    case SET_INDEX2: {
      return {
        ...state,
        index2: action.val,
      };
    }
    case SET_SOCKET_RECONNECT: {
      return {
        ...state,
        socketrefresh: action.val,
      };
    }
    default:
      return state;
  }
};
